import * as React from "react";

import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import AccountAnalysis from "./AccountAnalysis";
import WaivedEscrows from "./WaivedEscrows";

import WorksheetEditor from "web_modules/underwriter_dashboard/shared/WorksheetEditor";
const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface IProps {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
  withTabs: boolean;
}

class Escrows extends React.Component<IProps, any> {
  state = { updateCounter: 0 };

  render() {
    const { app, hurdle, onHide, withTabs } = this.props;

    const { updateCounter } = this.state;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <WaivedEscrows appId={app.id} />
        <WorksheetEditor
          appId={app.id}
          loanFileWsId={app.loan_file_worksheet_id}
          openToWsName="escrow_account"
        />
        <WorksheetEditor
          appId={app.id}
          loanFileWsId={app.loan_file_worksheet_id}
          openToWsName="escrows"
          onUpdate={() => {
            this.setState(prevState => {
              return { updateCounter: prevState.updateCounter + 1 };
            });
          }}
        />
        Initial Escrow Analysis
        <AccountAnalysis app={app} updateCounter={updateCounter} />
      </HurdleView>
    );
  }
}

export default Escrows;
